import { render, staticRenderFns } from "./GlobalSearchDestination.vue?vue&type=template&id=1dd1acb8&"
import script from "./GlobalSearchDestination.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchDestination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports